"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsService = void 0;
class PaymentsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * list paginated payments for creator
     * @param creatorId creator uuid
     * @param sortColumn
     * @param sortDir
     * @param paymentStatus
     * @param startDate
     * @param endDate
     * @param pageSize
     * @param pageToken
     * @returns SearchPaymentResponse
     * @throws ApiError
     */
    listPayments(creatorId, sortColumn, sortDir, paymentStatus, startDate, endDate, pageSize, pageToken) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payments/creators/{creatorId}/list',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'paymentStatus': paymentStatus,
                'startDate': startDate,
                'endDate': endDate,
                'pageSize': pageSize,
                'pageToken': pageToken,
                'sortColumn': sortColumn,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * Get all agency payments by agency id and its agents
     * @param id agency uuid
     * @param sortColumn
     * @param sortDir
     * @returns SearchPaymentResponse
     * @throws ApiError
     */
    getAgencyAgentsPayments(id, sortColumn, sortDir) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payments/agencies/{id}/agents',
            path: {
                'id': id,
            },
            query: {
                'sortColumn': sortColumn,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * Get a agent payment account status
     * @param id agent / creator uuid
     * @returns PaymentAccountStatusResponse
     * @throws ApiError
     */
    getAccountStatus(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payments/{id}/account/status',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Create a new agent payment account
     * @param agentId agent uuid
     * @returns UpdateResponse
     * @throws ApiError
     */
    createAgentAccount(agentId) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/payments/{agentId}/account',
            path: {
                'agentId': agentId,
            },
        });
    }
}
exports.PaymentsService = PaymentsService;
